import React, { useState, useEffect } from "react";

const Popup = () => {
  const [isOpen, setIsOpen] = useState(true);

  const closePopup = () => {
    setIsOpen(false);
    sessionStorage.setItem("popupClosed", "true"); // Save the closed state in sessionStorage
  };

  useEffect(() => {
    const popupClosed = sessionStorage.getItem("popupClosed");
    if (popupClosed === "true") {
      setIsOpen(false);
    }

    if (isOpen) {
      document.body.classList.add("popup-open");
    } else {
      document.body.classList.remove("popup-open");
    }
  }, [isOpen]);

  return (
    <div className="fixed left-4 bottom-4 z-50 xl:w-96 w-80 ">
      {" "}
      {isOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50"></div>
      )}
      <div
        className={`${
          isOpen ? "block" : "hidden"
        } bg-white p-4 shadow-md rounded-md relative z-50`}
      >
        <img
          src={process.env.PUBLIC_URL + "/icons/popup/Frame.png"}
          alt="happy"
          className="absolute top-0 right-0 w-12 h-12"
        />
        <h2 className="text-lg font-semibold">การตั้งค่าคุกกี้</h2>
        <p className="text-gray-600 text-sm xl:text-base mt-2">
          เราใช้คุกกี้ของเราเองเพื่อให้เราสามารถแสดงเว็บไซต์นี้
          แก่คุณและเข้าใจว่าคุณใช้คุกกี้เพื่อปรับปรุงบริการที่เรา นำเสนออย่างไร
        </p>
        <div className="mt-4 flex space-x-2">
          <a
            className="font-bold text-sm"
            href={window.location.origin + "/policy/"}
            onClick={closePopup}
          >
            ข้อกำหนดการใช้งาน
          </a>
          <a
            className="font-bold text-sm"
            href={window.location.origin + "/termsAndConditions#terms"}
            onClick={closePopup}
          >
            นโยบายความเป็นส่วนตัว
          </a>
        </div>
        <div className="mt-4 flex space-x-2">
          <button
            onClick={closePopup}
            className="px-3 py-1 border border-gray-400 rounded-md"
          >
            ปฏิเสธทั้งหมด
          </button>
          <button
            onClick={closePopup}
            className="px-3 py-1 bg-blue-500 text-white rounded-md"
          >
            ยอมรับทั้งหมด
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
